const patterns = [
  {
    technology: 'OOP',
  },
  {
    technology: 'MVC',
  },
  {
    technology: 'Scrum',
  },
  {
    technology: 'Agile',
  },
];

export default patterns;
